
<!-- <equal-height> -->
    <div class="row">
        <!-- <equal-width> -->
            <div class="col-xs-12">
                <div class="ib-layout__line-spacing">
                    <div class="ib-box ib-box--biggest ib-box--no-shadow">
                        <div class="ib-layout__line-spacing">
                            <h2 class="ib-heading-prebooking ib-heading-prebooking--primary ib-heading-prebooking--responsive  u-mb-xsmall">{{'CASH_AVIOS_INFO_TITLE'|translate}}</h2>
                            <span class="ib-heading-prebooking ib-heading-prebooking--subtitle ib-heading-prebooking--responsive">{{'CASH_AVIOS_INFO_SUBTITLE'|translate}}</span>
                        </div>
                        <div class="ib-layout__line-spacing ib-layout__line-spacing--large u-text-center u-display-table u-width-full">
                            <div class="ib-box-mini-info ib-box-mini-info--adaptative" *ngFor="let cashAviosOption of cashAviosModel" [ngClass]="{'ib-box-mini-info--small': cashAviosModel.length >= 5}">
                                <!-- data-equal-w="box" -->
                                <div class="ib-box-mini-info__container" data-equal="box">
                                    <span class="ib-box-mini-info__txt ib-box-mini-info__txt--group">
                                        <span class="ib-box-mini-info__txt ib-box-mini-info__txt--medium ib-box-mini-info__txt--special">{{'CASH_AVIOS_INFO_TEXT_1'|translate}}</span>
                                        <span class="ib-box-mini-info__txt ib-box-mini-info__txt--long ib-box-mini-info__txt--special">{{cashAviosOption.formatedTotalDiscount}}</span>
                                    </span>
                                    <span class="ib-box-mini-info__txt ib-box-mini-info__txt--unfocused">{{'CASH_AVIOS_INFO_TEXT_2'|translate}} {{cashAviosOption.formatedAviosRequired}} {{'CASH_AVIOS_INFO_TEXT_3'|translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="ib-layout__line-spacing ib-layout__line-spacing--medium u-mt-medium">
                            <span class="ib-text ib-text--responsive ib-text--avios u-text-center">{{'CASH_AVIOS_INFO_TEXT_4'|translate}}{{'CASH_AVIOS_INFO_TEXT_5'|translate}}
                            </span>
                        </div>
                        <div class="ib-layout__line-spacing ib-layout__line-spacing--null u-text-center" *ngIf="!isUserLogged">
                            <a class="ib-link ib-text-icon" href="javascript:void(0)" (click)="scrollToLogin()" title="{{'IB_PLUS_LOGIN_TEXT'|translate}}">
                                <span class="ib-link__icon ib-link__icon--primary ib-link__icon--small icon-perfil_login"></span>
                                <span class="ib-link__text ib-link__text--responsive">{{'IB_PLUS_LOGIN_TEXT'|translate}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </equal-width> -->
    </div>
<!-- </equal-height> -->
